import { render, staticRenderFns } from "./PayMeal.vue?vue&type=template&id=edcda48c&"
import script from "./PayMeal.vue?vue&type=script&lang=js&"
export * from "./PayMeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PayMeal.vue"
export default component.exports